import {Button} from "react-bootstrap";
import {saveTextAnswerExpertData} from "../../../actions";
import * as React from "react";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";

const TextAnswer = ({item}) => {
    // @ts-ignore
    const form_type = useSelector(state => state.forms.form_type);
    const dispatch = useDispatch();
    const [answerChange, setAnswerChange] = useState(undefined);
    const [answer, setAnswer] = useState('');

    return <div className="text-answer">
        <div className="text-answer__text">
            {
                answerChange ? <textarea
                    onChange={(e) => setAnswer(e.target.value)}
                /> : item.answer
            }
        </div>

        {
            !item.is_sent ? <div className="text-answer__btn">
                {
                    //@ts-ignore
                    !answerChange ? <button
                        onClick={() => {
                            setAnswerChange(true);
                            setAnswer(item.answer);
                        }}
                    >
                        Изменить ответ
                    </button> : null
                }

                {
                    //@ts-ignore
                    answerChange ? <button
                        onClick={() => {
                            saveTextAnswerExpertData(form_type, item.id, answer)(dispatch);
                            setAnswerChange(undefined);
                        }}
                    >
                        Сохранить
                    </button> : null
                }
            </div> : null
        }

    </div>;
}

export default TextAnswer;